import { Component, OnInit } from '@angular/core';
import { PublicService } from '../public.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  panelOpenState = false;
  number = 0
  historyArray: any = [];
  loading = true;
  id = "";
  // array = { date: any, money: string };

  constructor(public publicservice: PublicService, public router: Router) {
    if (publicservice.logedIn == "false" || this.publicservice.logedIn == null ) {
      this.router.navigate(['login']);
    }
    this.publicservice.getOrder().then(r => {
      this.loading = false;
     this.historyArray = r.data.orders;
      // this.router.navigate(['six-digit']);
    });
  }

  ngOnInit(): void {
  }

  backhome() {
    this.router.navigate(['home']);
  }

  cancel(id: any) {
    this.id = id;
    console.log(this.id);
    this.publicservice.cancelOrder(this.id).then(r => {
      if(r.message ==  "successful" && r.data == "delete has been successful") {
        this.loading = true;
        this.publicservice.getOrder().then(r => {
          this.loading = false;
         this.historyArray = r.data.orders;

        });
      }
    });

  }

}
